import { tail } from 'lodash';
import { merge } from 'ramda';
import { Language } from '~common/i18n';
import { TranslationFormData } from '~admin/view/components/ui/form/fields/field-translation.component';
import { isNilOrEmpty } from '~common/helper/global';

/**
 * Allows to merge translations into one map defined by language key
 * @param translationsMap
 * @param key
 * @param items
 */
export const mergeTranslations = <T>(
  translationsMap: Map<Language, T>,
  key: keyof T,
  items: TranslationFormData<any>[],
): void => {
  tail(items).forEach((item) => {
    // TODO(Dmitry & JF): Figure out this TypeScript mess
    if (!isNilOrEmpty(item.value)) {
      const newValue: any = { locale: item.language };
      newValue[key] = item.value;
      translationsMap.set(item.language, merge(translationsMap.get(item.language) ?? {}, newValue));
    }
  });
};

/**
 * Transforms translationsMap to an array.
 * @param translationsMap
 */
export const arrayTranslations = <T>(translationsMap: Map<Language, T>): T[] =>
  Array.from(translationsMap.values());

/**
 * Transforms translationsMap to a regular javascript object.
 * @param translationsMap
 */
export const mapTranslations = <T>(translationsMap: Map<Language, T>): { [key: string]: T } =>
  [...translationsMap.entries()].reduce((obj: { [key: string]: T }, [key, value]) => {
    obj[key] = value;
    return obj;
  }, {});

export const isNilOrEmptyTranslationString = (values: TranslationFormData<string>[]): boolean => {
  return isNilOrEmpty(values) || isNilOrEmpty(values[0].value);
};



// WEBPACK FOOTER //
// ./view/components/create-event/helper/merge-translations.helper.ts